export default __webpack_public_path__ + "static/Intern-profile-9fea5f06a4668606a15cbfef68c6ad88.webp";